import { alpha } from '@mui/material';
import { Mode, Skin } from '@webbyx/mui';

import { textPrimaryColor } from '../../config/colors';

/**
 * ===========================
 * MAIN
 * ===========================
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createThemeOverrideButton = (mode: Mode, skin: Skin) => {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          borderRadius: '8px',
        },
      },
      variants: [
        {
          props: { color: 'inherit' as any },
          style: {
            color: '#fff',
            background: textPrimaryColor,
            '&:hover': {
              color: '#fff',
              background: alpha(textPrimaryColor, 0.8),
            },
          },
        },
        {
          props: { variant: 'outlined' as any, color: 'inherit' as any },
          style: {
            color: textPrimaryColor,
            borderColor: textPrimaryColor,
            background: 'transparent',
            '&:hover': {
              color: textPrimaryColor,
              background: alpha(textPrimaryColor, 0.2),
            },
          },
        },
      ],
    },
  };
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default createThemeOverrideButton;
